module.exports = __webpack_public_path__ + "img/marydeevargas.79b4937d.jpg";